import { Component } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [FooterComponent, StaticSearchComponent, CommonHeaderComponent],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
})
export class TermsAndConditionsComponent {
  constructor(private titleService: Title, private metaService: Meta) {
    this.titleService.setTitle(
      'Middle East Travel Advice & Safety | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content: `World2cover travel insurance terms and conditions apply.`,
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Middle East Travel Advice & Safety | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content: `World2cover travel insurance terms and conditions apply.`,
    });
  }
}
